export const scaleShopifyImage = (url: string | undefined, size: string) =>
  url?.includes("cdn.shopify.com") ? url.replace(/^(.+?)(.(?:png|jpg|webp).+)$/, `$1_${size}$2`) : url
